/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWGameSteamDataPcRequirements
 */
export interface OWGameSteamDataPcRequirements {
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamDataPcRequirements
     */
    minimum?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamDataPcRequirements
     */
    recommended?: string;
}

export function OWGameSteamDataPcRequirementsFromJSON(json: any): OWGameSteamDataPcRequirements {
    return OWGameSteamDataPcRequirementsFromJSONTyped(json, false);
}

export function OWGameSteamDataPcRequirementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSteamDataPcRequirements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'minimum': !exists(json, 'minimum') ? undefined : json['minimum'],
        'recommended': !exists(json, 'recommended') ? undefined : json['recommended'],
    };
}

export function OWGameSteamDataPcRequirementsToJSON(value?: OWGameSteamDataPcRequirements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'minimum': value.minimum,
        'recommended': value.recommended,
    };
}


